document.addEventListener('DOMContentLoaded', () => {
  // Function to initialize part finders
  function initializeFinders() {
    const finders = document.querySelectorAll('garage-finder');

    finders.forEach((finder) => {
      // Prevent reinitializing already-initialized finders
      if (finder.dataset.initialized === 'true') return;

      const yearDropdown = finder.querySelector('.year-dropdown');
      const makeDropdown = finder.querySelector('.make-dropdown');
      const modelDropdown = finder.querySelector('.model-dropdown');
      const searchButton = finder.querySelector('.search-button'); // Now an <a> tag

      if (!yearDropdown || !makeDropdown || !modelDropdown || !searchButton) return;

      finder.dataset.initialized = 'true'; // Mark finder as initialized

      // Topbar mode: the current collection's filter params (built in Liquid from the
      // collection.finder_filters metafield) are appended to the model collection URL,
      // e.g. /collections/2026-aprilia-rs457?filter.p.product_type=Brake+Pads
      const filterQuery = finder.dataset.filterQuery || '';
      const buildHref = (collectionUrl) => {
        if (!filterQuery) return collectionUrl;
        return collectionUrl + (collectionUrl.includes('?') ? '&' : '?') + filterQuery;
      };

      // Inside the filter top bar the finder sits in the theme's filter <form>;
      // stop our select changes bubbling so the theme doesn't treat them as filters.
      [yearDropdown, makeDropdown, modelDropdown].forEach((dropdown) => {
        dropdown.addEventListener('change', (event) => event.stopPropagation());
      });

      function addOptions(dropdown, options, defaultTitle) {
        dropdown.innerHTML = `<option value="">${defaultTitle}</option>`;
        options.forEach((optionData) => {
          const option = document.createElement('option');
          option.value = optionData.value || '';
          option.textContent = optionData.text || '';
          if (optionData.disabled) {
            option.disabled = true;
          }
          dropdown.appendChild(option);
        });
      }

      // Populate Year Dropdown
      addOptions(yearDropdown, jsonData.years.map(year => ({
        value: year.year,
        text: year.year
      })), 'Motorcycle Year');

      const normalise = (url) => (url || '').split('?')[0].replace(/\/+$/, '').toLowerCase();

      const disableSearch = () => {
        searchButton.setAttribute('disabled', 'true');
        searchButton.setAttribute('aria-disabled', 'true');
        searchButton.removeAttribute('href');
      };

      // Topbar on a Model collection: selecting the collection we're already on
      // leaves the button disabled (there's nowhere to go).
      const currentUrl = normalise(finder.dataset.preselectUrl);

      const enableSearch = (collectionUrl) => {
        if (currentUrl && normalise(collectionUrl) === currentUrl) {
          disableSearch();
          return;
        }
        searchButton.removeAttribute('disabled');
        searchButton.removeAttribute('aria-disabled');
        searchButton.href = buildHref(collectionUrl);
      };

      // Populate makes for a year (returns the year's data or null)
      const populateMakes = (selectedYear) => {
        const yearData = jsonData.years.find((y) => y.year === selectedYear);

        if (yearData) {
          const popularMakes = ['Honda', 'Yamaha', 'Kawasaki', 'BMW', 'Ducati', 'Harley Davidson', 'Triumph', 'Suzuki', 'KTM', 'Aprilia'];

          const popularOptions = [];
          const otherOptions = [];

          yearData.makes.forEach((makeData) => {
            const option = { value: makeData.make, text: makeData.make };
            if (popularMakes.includes(makeData.make)) {
              popularOptions.push(option);
            } else {
              otherOptions.push(option);
            }
          });

          popularOptions.sort((a, b) => a.text.localeCompare(b.text));
          otherOptions.sort((a, b) => a.text.localeCompare(b.text));

          const combinedOptions = [
            { value: '', text: '-- Popular Makes --', disabled: true },
            ...popularOptions,
            { value: '', text: '-- Other Makes --', disabled: true },
            ...otherOptions,
          ];

          addOptions(makeDropdown, combinedOptions, 'Motorcycle Make');
          makeDropdown.disabled = false;
          return yearData;
        }

        makeDropdown.disabled = true;
        addOptions(makeDropdown, [], 'Motorcycle Make');
        return null;
      };

      // Populate models for a year + make (returns the make's data or null)
      const populateModels = (selectedYear, selectedMake) => {
        const yearData = jsonData.years.find((y) => y.year === selectedYear);
        const makeData = yearData?.makes.find((m) => m.make === selectedMake);

        if (makeData) {
          const modelOptions = makeData.models.map((model) => ({
            value: model.collection_url,
            text: model.name,
          }));

          addOptions(modelDropdown, modelOptions, 'Motorcycle Model');
          modelDropdown.disabled = false;
          return makeData;
        }

        modelDropdown.disabled = true;
        addOptions(modelDropdown, [], 'Motorcycle Model');
        return null;
      };

      // Re-apply previous make/model after an upstream change, keeping whatever is
      // still valid: same make for the new year → keep it; same model name under
      // that make → keep it too (its collection URL may differ per year, so match
      // by name and take the new URL).
      const reapply = (previousMake, previousModelName) => {
        const year = yearDropdown.value;
        const yearData = populateMakes(year);
        disableSearch();

        if (!yearData) {
          addOptions(modelDropdown, [], 'Motorcycle Model');
          modelDropdown.disabled = true;
          return;
        }

        const makeStillValid = yearData.makes.some((m) => m.make === previousMake);
        if (!makeStillValid) {
          addOptions(modelDropdown, [], 'Motorcycle Model');
          modelDropdown.disabled = true;
          return;
        }

        makeDropdown.value = previousMake;
        const makeData = populateModels(year, previousMake);
        if (!makeData) return;

        const model = makeData.models.find((m) => m.name === previousModelName);
        if (model) {
          modelDropdown.value = model.collection_url;
          enableSearch(model.collection_url);
        }
      };

      const selectedModelName = () =>
        modelDropdown.value ? modelDropdown.options[modelDropdown.selectedIndex].text : '';

      // Handle Year Dropdown Change
      yearDropdown.addEventListener('change', () => {
        reapply(makeDropdown.value, selectedModelName());
      });

      // Handle Make Dropdown Change
      makeDropdown.addEventListener('change', () => {
        const previousModelName = selectedModelName();
        disableSearch();
        const makeData = populateModels(yearDropdown.value, makeDropdown.value);
        if (!makeData) return;

        const model = makeData.models.find((m) => m.name === previousModelName);
        if (model) {
          modelDropdown.value = model.collection_url;
          enableSearch(model.collection_url);
        }
      });

      // Handle Model Dropdown Change
      modelDropdown.addEventListener('change', () => {
        if (modelDropdown.value) {
          enableSearch(modelDropdown.value);
        } else {
          disableSearch();
        }
      });

      // Topbar on a Model collection: preselect the current model (data-preselect-url)
      const preselectUrl = currentUrl;

      if (preselectUrl) {
        let found = null;
        outer: for (const yearData of jsonData.years) {
          for (const makeData of yearData.makes) {
            for (const model of makeData.models) {
              if (normalise(model.collection_url) === preselectUrl) {
                found = { year: yearData.year, make: makeData.make, model };
                break outer;
              }
            }
          }
        }

        if (found) {
          yearDropdown.value = found.year;
          populateMakes(found.year);
          makeDropdown.value = found.make;
          populateModels(found.year, found.make);
          modelDropdown.value = found.model.collection_url;
          enableSearch(found.model.collection_url);
        }
      }
    });
  }

  // Initialize all part finders on page load
  initializeFinders();

  // Safeguarded MutationObserver to watch for menu changes
  const observer = new MutationObserver((mutations) => {
    let foundNewContent = false;

    mutations.forEach((mutation) => {
      if (mutation.addedNodes && mutation.addedNodes.length > 0) {
        foundNewContent = true;
      }
    });

    if (foundNewContent) {
      initializeFinders(); // Reinitialize when new elements are added
    }
  });

  // Start observing the body for changes, with safeguards
  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
});
